module.exports = __webpack_public_path__ + "img/box2_img2.caffdb11.png";